import { useDispatch, useSelector } from "react-redux";
import { ResetPasswordAction } from "../coworkers/components/reset_password_action";
import { TextBox } from "../../components/inputs";
import { useFormikWrapper } from "../../components/formik_wrapper";
import * as Yup from "yup";
import { RESETCOWORKERPWD_REQ, RESET_STATE } from "../../actions";
import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import { RESETCOWORKERPWD_RESPONSE } from "../../constants/action_types";
import { FlatButton } from "../../components/buttons";
import { Reset2FA } from "../coworkers/components/reset2fa";
import { Popup } from "../../components/pop-up";

export function SecuritySettings() {
  const dispatch = useDispatch();

  const coworkerDetails = useSelector(
    (state) => state?.coworker?.details?.coworker
  );

  const [qrCode, setQRcode] = useState();
  const [openModal, setOpenModal] = useState();
  const [modalState, setModalState] = useState();

  const coworkerUpdated = useSelector(
    (state) => state?.coworker?.update_response
  );

  useEffect(() => {
    if (coworkerUpdated?.type === RESETCOWORKERPWD_RESPONSE) {
      setQRcode(coworkerUpdated?.payload?.data);
    }
  }, [coworkerUpdated]);

  useEffect(() => {
    if (qrCode) setModalState("pop-up");
  }, [qrCode]);

  const closeModal = () => {
    dispatch(RESET_STATE("coworker.update_response"));
    setModalState(undefined);
    setQRcode(undefined);
    resetForm();
  };

  const resetForm = () => {
    passwordForm.setTouched({
      password: false,
      confirm_password: false,
    });
    passwordForm.setValues({
      password: "",
      confirm_password: "",
    });
  };

  const passwordForm = useFormikWrapper({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Please enter the password")
        .min(8, "Password must be atleast 8 characters"),
      confirm_password: Yup.string()
        .required("Please confirm the password")
        .oneOf([Yup.ref("password")], "Your passwords do not match."),
    }),
    onSubmit: () => {
      setOpenModal("pop-up");
    },
  });
  return (
    <>
      <div className="text-left mb-5 flex flex-col mt-8 p-5 h-full">
        <TextBox
          type="password"
          className="mb-4"
          name="password"
          label="Enter new password"
          placeholder="New Password"
          formik={passwordForm}
        />
        <TextBox
          type="password"
          name="confirm_password"
          label="Confirm new password"
          placeholder="Re-type new Password"
          formik={passwordForm}
        />
        <div className="mt-8 col-span-5 flex gap-x-5 items-center justify-between">
          <Reset2FA data={coworkerDetails} type="text" />
          <div className="mt-8 col-span-5 flex gap-x-5 items-center justify-between">
            <FlatButton
              size="lg"
              appearance="secondary"
              disabled={!passwordForm.dirty}
              onClick={() => {
                resetForm();
              }}
              className="w-[120px]"
            >
              Cancel
            </FlatButton>
            <FlatButton
              size="lg"
              onClick={() => {
                passwordForm.submitForm();
              }}
              className="w-[120px]"
            >
              Save
            </FlatButton>
          </div>
        </div>
      </div>
      <Popup
        modalState={[openModal, setOpenModal]}
        onConfirm={() => {
          setOpenModal();
          dispatch(
            RESETCOWORKERPWD_REQ({
              ...coworkerDetails,
              ...passwordForm.values,
            })
          );
        }}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to change your password?
            </h3>
          </>
        }
      />
      <Modal
        show={modalState === "pop-up"}
        size="2xl"
        popup
        onClose={() => closeModal()}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="flex flex-row flex-nowrap items-center">
            {qrCode && (
              <>
                <img className="h-13 w-13" src={qrCode.qr} alt="" />
                <h3 className="mb-5 ml-4 text-md font-normal text-gray-500 dark:text-gray-500">
                  Coworker's password has been updated successfully.
                  <br />
                  <br /> Please Scan the QR Code with Google Authenticator and
                  Save this Secret key to recover account incase if lost.
                  <br />
                  <p
                    className="cursor-pointer text-blue-500 text-underline"
                    onClick={() => {
                      window.open(qrCode.qr);
                    }}
                  >
                    Click here
                  </p>{" "}
                  to open QR Code in new tab <br />
                  <br />
                  <b className="font-bold text-md ">
                    SECRET KEY:
                    <br /> ${qrCode.secret_key}
                  </b>
                </h3>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
